import { z } from 'zod';

/**
 * Frozen Phase 0 (schema v1) music shapes, used only to validate documents before the
 * v1 → v2 migration. Do not change: they describe data that already exists in browsers.
 */
export const V1StepSchema = z.object({
  active: z.boolean(),
  velocity: z.number().min(0).max(1),
  note: z.string().regex(/^[A-G](#|b)?[0-6]$/).optional(),
});

export const V1TrackSchema = z.object({
  id: z.string(),
  name: z.string(),
  instrument: z.enum(['kick', 'snare', 'hats', 'bass']),
  muted: z.boolean(),
  volumeDb: z.number().min(-60).max(6),
  clips: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        startBeat: z.number(),
        lengthBeats: z.number(),
        pattern: z.object({ steps: z.array(V1StepSchema).length(16) }),
      }),
    )
    .max(256),
});

export const V1MusicSchema = z.object({
  schemaVersion: z.literal(1),
  settings: z.object({ bpm: z.number(), swing: z.number(), masterVolumeDb: z.number() }),
  tracks: z.array(V1TrackSchema).max(64),
});
export type V1Track = z.infer<typeof V1TrackSchema>;
